import { QueryFunction, useMutation, useQuery } from "@tanstack/react-query";

const useService = (label: string, fnActions: QueryFunction) => {
    const serviceQuery = useQuery({
        queryKey: [label],
        queryFn: fnActions,
    });
    return serviceQuery;
}

const useSaveService = (fnActions: any) => {
    const saveQuery = useMutation(fnActions);
    return saveQuery;
}

export { useService, useSaveService }